export const ExternalProgramCodes = {
    HESLP: 'HESLP'
} as const;
